import { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getClinic, saveClinic } from "@/lib/dentiumApi";
import { SettingsCard, SaveButton } from "@/components/settings/SettingsCard";

const FIELDS = [
  { key: "name", label: "Nombre de la clínica", placeholder: "Clínica dental", span: false },
  { key: "city", label: "Ciudad", placeholder: "Ciudad", span: false },
  { key: "phone", label: "Teléfono", placeholder: "+34 600 000 000", span: false },
  { key: "email", label: "Email de contacto", placeholder: "hola@tuclinica.com", span: false },
  { key: "address", label: "Dirección", placeholder: "Calle, número, CP, ciudad", span: true },
];

export const ClinicDataPanel = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["clinic"], queryFn: getClinic });
  const [form, setForm] = useState(null);
  useEffect(() => { if (data) setForm(data); }, [data]);

  const save = useMutation({
    mutationFn: () => saveClinic(form),
    onSuccess: (d) => {
      qc.setQueryData(["clinic"], d);
      qc.invalidateQueries({ queryKey: ["bot-messages"] });
      toast.success("Datos de la clínica guardados");
    },
    onError: (e) => toast.error(e?.response?.data?.detail?.toString?.() || "No se pudieron guardar los datos"),
  });

  if (!form) return null;
  return (
    <SettingsCard icon={Building2} title="Datos de la clínica" testid="clinic-config-panel"
      description="Se muestran en el menú lateral, en el acceso al panel y los usa el bot al hablar con los pacientes.">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.span ? "sm:col-span-2" : ""}>
            <Label className="mb-1.5 block">{f.label}</Label>
            <Input data-testid={`clinic-${f.key}-input`} value={form[f.key] || ""} placeholder={f.placeholder}
              onChange={(e) => setForm((s) => ({ ...s, [f.key]: e.target.value }))} />
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-5">
        <SaveButton testid="save-clinic-btn" pending={save.isPending} disabled={!form.name?.trim()} onClick={() => save.mutate()} />
      </div>
    </SettingsCard>
  );
};
